import drawerMessages from '../messages';

export const TIME_PERIOD = Object.freeze({
  DAYS_30: '30days',
  DAYS_60: '60days',
  MONTHS_3: '3months',
  MONTHS_6: '6months',
  YEAR_1: '1year',
  YEARS_2: '2years',
});

// Unified time period definitions with all metadata
export const TimePeriod = Object.freeze({
  [TIME_PERIOD.DAYS_30]: {
    key: TIME_PERIOD.DAYS_30,
    months: 1,
    dataPoints: 1,
    messageDescriptor: drawerMessages.dateRange30Days,
  },
  [TIME_PERIOD.DAYS_60]: {
    key: TIME_PERIOD.DAYS_60,
    months: 2,
    dataPoints: 2,
    messageDescriptor: drawerMessages.dateRange60Days,
  },
  [TIME_PERIOD.MONTHS_3]: {
    key: TIME_PERIOD.MONTHS_3,
    months: 3,
    dataPoints: 3,
    messageDescriptor: drawerMessages.dateRange3Months,
  },
  [TIME_PERIOD.MONTHS_6]: {
    key: TIME_PERIOD.MONTHS_6,
    months: 6,
    dataPoints: 6,
    messageDescriptor: drawerMessages.dateRange6months,
  },
  [TIME_PERIOD.YEAR_1]: {
    key: TIME_PERIOD.YEAR_1,
    months: 12,
    dataPoints: 12,
    messageDescriptor: drawerMessages.dateRange1Year,
  },
  [TIME_PERIOD.YEARS_2]: {
    key: TIME_PERIOD.YEARS_2,
    months: 24,
    dataPoints: 24,
    messageDescriptor: drawerMessages.dateRange2Years,
  },
});

// Configuration arrays defining which periods are available for each context
const FORECAST_PERIODS = [TIME_PERIOD.DAYS_30, TIME_PERIOD.DAYS_60, TIME_PERIOD.MONTHS_3, TIME_PERIOD.MONTHS_6, TIME_PERIOD.YEAR_1];

const LOOKBACK_PERIODS = [TIME_PERIOD.DAYS_30, TIME_PERIOD.MONTHS_3, TIME_PERIOD.MONTHS_6, TIME_PERIOD.YEAR_1, TIME_PERIOD.YEARS_2];

// Default values
export const DEFAULT_FORECAST_PERIOD = TIME_PERIOD.DAYS_60;
export const DEFAULT_LOOKBACK_PERIOD = TIME_PERIOD.YEAR_1;

// New utility functions for getting available periods
/**
 * Get all available forecast periods with their metadata
 * @returns {object[]} Array of forecast period objects
 */
export const getForecastPeriods = () => FORECAST_PERIODS.map((key) => TimePeriod[key]);

/**
 * Get all available lookback periods with their metadata
 * @returns {object[]} Array of lookback period objects
 */
export const getLookbackPeriods = () => LOOKBACK_PERIODS.map((key) => TimePeriod[key]);

/**
 * Get forecast period values for dropdowns
 * @returns {string[]} Array of forecast period keys
 */
export const getForecastPeriodValues = () => FORECAST_PERIODS;

/**
 * Get lookback period values for dropdowns
 * @returns {string[]} Array of lookback period keys
 */
export const getLookbackPeriodValues = () => LOOKBACK_PERIODS;
